module.exports = __webpack_public_path__ + "img/rancher-logo.1e6dbd1d.svg";